import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import AppNavigation from './AppNavigation';

export default function Profile() {
  const { currentUser, logout, updateProfile } = useAuth();
  const [displayName, setDisplayName] = useState(currentUser?.displayName || '');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    try {
      setError('');
      await logout();
    } catch (err) {
      setError('Failed to log out');
      console.error('Logout error:', err);
    }
  };

  const handleUpdateProfile = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      setError('');
      setSuccess('');
      setLoading(true);
      
      await updateProfile(displayName);
      setSuccess('Profile updated successfully');
    } catch (err) {
      setError('Failed to update profile');
      console.error('Profile update error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!currentUser) {
    return null;  // Or redirect to login
  }

  return (
    <div className="app-container">
      <Sidebar currentUser={currentUser} />
      
      <div className="main-content with-sidebar">
        <AppNavigation />
        
        <div className="App">
          <div className="profile-container">
            <h2>Profile</h2>
            
            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}
            
            <div className="user-info">
              <p><strong>Email:</strong> {currentUser.email}</p>
            </div>
            
            <form onSubmit={handleUpdateProfile}>
              <div className="form-group">
                <label htmlFor="displayName">Display Name</label>
                <input
                  id="displayName"
                  type="text"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                />
              </div>
              
              <button type="submit" disabled={loading}>
                Update Profile
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
} 